module.exports = __webpack_public_path__ + "static/interstate-106194161199fe5f4887790e37334c58.otf";